/*!

=========================================================
* Argon Dashboard PRO React - v1.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-pro-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
// nodejs library that concatenates classes
// JavaScript library that creates a callendar with events
import { Calendar } from "@fullcalendar/core";
import dayGridPlugin from "@fullcalendar/daygrid";
import interaction from "@fullcalendar/interaction";
// react component used to create sweet alerts
// reactstrap components
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  FormGroup,
  Form,
  Input,
  Modal,
  Container,
  Row,
  Col,
} from "reactstrap";
// core components

import { request } from "network/Request";

let calendar;

function ExamAuction() {
  const [events, setEvents] = React.useState(null);
  const [currentDate, setCurrentDate] = React.useState(null);
  const [alert, setAlert] = React.useState(null);
  const [modalChange, setModalChange] = React.useState(false);
  const [multipleResult, setMultipleResult] = React.useState(false);
  const [noResult, setNoResult] = React.useState(false);
  const [ad, setAd] = React.useState(null);
  const [ymd, setYMD] = React.useState(null);
  // eslint-disable-next-line
  const calendarRef = React.useRef(null);
  React.useEffect(() => {
    createCalendar();
    auctionState();
  });

  const createCalendar = () => {
    calendar = new Calendar(calendarRef.current, {
      plugins: [interaction, dayGridPlugin],
      initialView: "dayGridMonth",
      selectable: true,
      editable: true,
      events: events,
      headerToolbar: "",
      // Add new event
      // Edit calendar event action
      eventClick: ({ event }) => {
        console.log(event);
        if (event["title"] === "마감")
          return;
        setYMD(event["id"])
        setModalChange(true);
      },
    });
    calendar.render();
    setCurrentDate(calendar.view.title);
  };

  const auctionState = () => {
    if (events != null)
      return;
    console.log("auction state request");
    request({
      "bk-working": "exam-reserve-state",
    }, (result, response) => {
      const reserve = response["reserve_state_json"];
      const reserving = reserve["reserving_array"];
      const soldoutArray = reserve["soldout_array"];

      console.log(response);

      const reservingEvent = reserving.map((item, index) => {
        var soldout = false;
        for (var i in soldoutArray) {
          if (soldoutArray[i] === item)
            soldout = true;
        }
        return {
          id: item,
          start: to_date2(item),
          title: soldout ? "마감" : (response["coin"] + " 코인"),
          allDay: true,
          className: soldout ? "bg-grey" : "bg-red",
          description: "구매 가능합니다."
        }
      });

      if (reservingEvent != null)
          setEvents(reservingEvent);
    });
  }

  const to_date2 = (yyyyMMdd) => {

    var sYear = yyyyMMdd.substring(0, 4);
    var sMonth = yyyyMMdd.substring(4, 6);
    var sDate = yyyyMMdd.substring(6, 8);
    //alert("sYear :"+sYear +"   sMonth :"+sMonth + "   sDate :"+sDate);
    return new Date(Number(sYear), Number(sMonth) - 1, Number(sDate));
  }

  const searchAd = () => {
    setMultipleResult(false);
    setNoResult(false);
    var filterText = document.getElementById("search_text").value;
    request({
      "bk-working": "my-content-search-ids",
      "search_text": filterText
    }, (result, response) => {
      const ids = response["searched_ids"];
      if (ids.length > 1) {
        setMultipleResult(true);
      } else if (ids.length <= 0) {
        setNoResult(true);
      } else {
        getAd(ids);
      }
    });
  }

  const getAd = (ids) => {
    console.log(ids);
    request({
      "bk-working": "content-search",
      "searched_ids": ids
    }, (result, response) => {
      console.log(response["searched_array"][0]);
      setAd(response["searched_array"][0]);
    });
  }

  const registerAuction = (adId) => {
    if (adId == null || adId === 0) {
      alert("올바르지 않은 콘텐츠입니다.");
      return;
    }
    console.log(ymd);
    request({
      "bk-working": "exam-reserve",
      "ad_id": adId,
      "exam_reserve_time": ymd,
    }, (result, response) => {
      
    });
  }

  return (
    <>
      {alert}
      <div className="header header-dark bg-info pb-6 content__title content__title--calendar">
        <Container fluid>
          <div className="header-body">
            <Row className="align-items-center py-4">
              <Col lg="6">
              <h6 className="fullcalendar-title h2 text-white d-inline-block mb-0 mr-1">
                  {currentDate}
                </h6>
              </Col>
              <Col className="mt-3 mt-md-0 text-md-right" lg="6">
                <Button
                  className="fullcalendar-btn-prev btn-neutral"
                  color="default"
                  onClick={() => {
                    calendar.next();
                  }}
                  size="sm"
                >
                  <i className="fas fa-angle-left" />
                </Button>
                <Button
                  className="fullcalendar-btn-next btn-neutral"
                  color="default"
                  onClick={() => {
                    calendar.prev();
                  }}
                  size="sm"
                >
                  <i className="fas fa-angle-right" />
                </Button>
              </Col>
            </Row>
          </div>
        </Container>
      </div>
      <Container className="mt--6" fluid>
        <Row>
          <div className="col">
            <Card className="card-calendar">
              <CardHeader>
                <h5 className="h3 mb-0">Calendar</h5>
              </CardHeader>
              <CardBody className="p-0">
                <div
                  className="calendar"
                  data-toggle="calendar"
                  id="calendar"
                  ref={calendarRef}
                />
              </CardBody>
            </Card>
            <Modal
              isOpen={modalChange}
              toggle={() => setModalChange(false)}
              className="modal-dialog-centered modal-secondary"
            >
              <div className="modal-body">
                <Form className="edit-event--form">
                  <FormGroup>
                    <label className="form-control-label">검색어 입력</label>
                    <Input
                      id="search_text"
                      className="form-control-alternative edit-event--title"
                      placeholder="검색어"
                      type="text"
                    />

                    <Button
                      color="danger"
                      onClick={() => {
                        searchAd();
                      }}
                    >
                      검색
                    </Button>
                  </FormGroup>
                  {multipleResult ? "검색결과가 2개 이상입니다." : noResult ? "검색결과가 없습니다." :
                    ad != null ? ad["ad_english"] + "\n" + ad["ad_translation"] : ""}
                </Form>
              </div>
              <div className="modal-footer">
                <Button color="primary" onClick={() => registerAuction(ad["ad_id"])}>
                  등록
                </Button>
                <Button
                  className="ml-auto"
                  color="link"
                  onClick={() => setModalChange(false)}
                >
                  Close
                </Button>
              </div>
            </Modal>
          </div>
        </Row>
      </Container>
    </>
  );
}

export default ExamAuction;
